"use client";

import { Branding } from "@/types/branding";
import { I18nData } from "@/types/i18n";
import ResultsTable from "./results-table";
import MobileResults from "./mobile-results";
import { useIsMobile } from "@/hooks/use-is-mobile";

interface Props {
  branding: Branding | null;
  i18nData: I18nData;
}

export default function Results({ branding, i18nData }: Props) {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return <ResultsTable branding={branding} i18nData={i18nData} />;
  }

  return isMobile ? (
    <MobileResults branding={branding} i18nData={i18nData} />
  ) : (
    <ResultsTable branding={branding} i18nData={i18nData} />
  );
}
